import { AxiosPromise } from 'axios';

import { ApiService } from './api.service';
import { PromotionalCode } from 'app/shared/interfaces/PromotionalCode.interface';
import {
  Referral,
  ReferralStats,
  SkpEmployeeReferralStats,
} from 'app/shared/interfaces/Referral.interface';
import { PromotionState } from 'app/store/data/promotion';

export const PromotionCodeService = {
  setPromotionCode(
    quotationId: string,
    promotionId: string | null,
    promotionPartnerId: string | null,
    resultId: string | null,
    offerId: string | null,
    promotionRemovalInfo: {
      reason: string;
      message: string;
    } | null
  ): AxiosPromise<PromotionalCode> {
    return ApiService.patch(
      `car-insurances/quotations/${quotationId}/promotions`,
      {
        promotionId,
        promotionPartnerId,
        resultId,
        offerId,
        promotionRemovalInfo,
      }
    );
  },
  getPromotion(
    quotationId: string,
    partial: boolean,
    resultId: string | null,
    offerId: string | null
  ): AxiosPromise<PromotionState> {
    return ApiService.get(
      `car-insurances/quotations/${quotationId}/promotions`,
      {
        params: {
          resultId,
          offerId,
          partial: partial ? '1' : null,
        },
      }
    );
  },
  getPromotionData(promotionId: string): AxiosPromise<PromotionalCode> {
    return ApiService.get(`dictionaries/promotions/${promotionId}`);
  },
  getVoucherData(quotationId?: string): AxiosPromise<Referral> {
    const endpoint = quotationId
      ? `car-insurances/quotations/referral-codes/${quotationId}`
      : 'referral-codes';
    return ApiService.get(endpoint);
  },
  getVoucherStats(): AxiosPromise<ReferralStats | SkpEmployeeReferralStats> {
    return ApiService.get('car-insurances/quotations/stats/recommendations');
  },
  sendInvitations(emails: Array<string>): AxiosPromise {
    return ApiService.post('users/email-recommendations', { emails: emails });
  },
};
